module.exports = __webpack_public_path__ + "static/sports-category-1bb61e1357d5fa75ca310e652233e8d7.png";